import PropTypes from 'prop-types';
import React from 'react'

import { Icon } from '~/components'


export default class extends React.Component {
    static propTypes = {
		filter: PropTypes.string,
		changeTab: PropTypes.func.isRequired,
		hideCamps: PropTypes.bool
	};

    changeTab = (icon) => {
		return this.props.changeTab(icon)
	};

    createIcon = (title, icon) => {
		return <div className={"tab clickable " + (this.props.filter == icon ? 'selected' : '')} onClick={this.changeTab.bind(this, icon)}>
			<Icon icon={icon} className="text-mid-main" /> {title}
		</div>
	};

    render() {

		return (

			<div className="row pbot15-sm">
	            <div className="col-md-2 pleft0">
					<div className="tab-header">
						{ ( !('hideCamps' in this.props) || !this.props.hideCamps ) && <div className="tab"><Icon icon='camps' /> <strong>Camps</strong></div> }
					</div>
	            </div>
	            <div className="col-md-3 col-md-offset-7">
					<div className="tab-header text-center">
						{ this.createIcon('Bookmarks', 'bookmarks') }
						{ this.createIcon('History', 'history') }
					</div>
	            </div>
            </div>

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Community/DashboardParts/DashboardHeader.jsx